/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(joinCode) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      SubmitRegisterJoinCode: {
        $xmlns: 'http://dobs.pa.gov/cs/joincode/bpm/1.0',
        JoinCode: joinCode
      }
    },
    blueprint: {
      result: '$..Result.__text',
      resultMessage: '$..ResultMessage.__text'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      response.result = response.result === '1';

      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
